var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LogsList',{attrs:{"title":_vm.title,"data":_vm.data,"totalDocs":_vm.totalDocs,"page":_vm.page,"noDataText":_vm.noDataText,"hasNext":_vm.hasNext,"hasPrev":_vm.hasPrev,"displayAll":true},on:{"fetchList":_vm.getLogs}})
}
var staticRenderFns = []

export { render, staticRenderFns }